import { Component } from '@angular/core';

import { PortalApiService } from '../../portal-api.service';
import { PortalAuthService } from '../../portal-auth.service';
import { PortalModalBaseComponent } from '../portal-modal/portal-modal-base.component';

// "Reject Reason" picker. Extends the reusable portal-modal. On submit it records
// the reason/comment as an activity note and cancels the quote, then emits the
// quote so the opening page can update its local state.
@Component({
	selector: 'portal-reject-modal',
	templateUrl: './reject-modal.component.html'
})
export class RejectModalComponent extends PortalModalBaseComponent {

	readonly reasons: string[] = [
		'Too Expensive',
		'No Longer Required',
		'Prefer a Different Solution',
		'Not the Right Time',
		'Scope Doesn\'t Meet My Needs',
		'Found Another Contractor',
		'Decided Not to Proceed',
		'Other'
	];

	quote: any = null;
	selectedReason: string | null = null;
	comment = '';
	saving = false;
	error = '';

	constructor(private api: PortalApiService, private auth: PortalAuthService) {
		super();
	}

	get subtitle(): string {
		if (!this.quote) return '';
		const title = this.quote.title || this.quote.description || '';
		return `Tell us why you are declining this quote: Quote #${this.quote.quote_no}${title ? ' – ' + title : ''}`;
	}

	get needsComment(): boolean {
		return this.selectedReason === 'Other';
	}

	/**
	 * Why submit is unavailable, for the button's tooltip — null while it is usable.
	 *
	 * Mirrors canSubmit, minus the saving case: the button's own label already reads "Saving…".
	 */
	get submitBlockedReason(): string | null {
		if (this.saving) return null;
		if (!this.selectedReason) return 'Choose a reason to continue';
		if (this.needsComment && !this.comment.trim()) return 'Add a comment to continue';
		return null;
	}

	get canSubmit(): boolean {
		if (!this.selectedReason || this.saving) return false;
		if (this.needsComment && !this.comment.trim()) return false;
		return true;
	}

	open(quote: any): void {
		this.quote = quote;
		this.selectedReason = null;
		this.comment = '';
		this.error = '';
		this.saving = false;
		this.modal.open();
	}

	submit(): void {
		if (!this.canSubmit || !this.quote) return;
		this.saving = true;
		this.error = '';
		this.api.quote.reject(this.quote.id, {
			reason: this.selectedReason,
			comment: this.comment.trim()
		}, () => {
			this.saving = false;
			this.modal.close({ quote: this.quote });
		}, (err: any) => {
			this.saving = false;
			// Session gone mid-action — sign in again and come back to this page,
			// rather than leaving them stuck on an inline error.
			if (err?.status === 401) { this.modal.close(); this.auth.goToLogin(); return; }
			this.error = err?.message || 'Could not submit right now. Please try again.';
		});
	}
}
